export enum FilterValueKey {
    startDate = 'startDate',
    endDate = 'endDate',
    reportType = 'reportType',
    states = 'states',
    ownerProfileId = 'ownerProfileId',
}

export enum ExportsPageTabs {
    History = 'history',
    Scheduled = 'scheduled',
}

export const REPORT_TYPE_WITHOUT_DETAILS = ['SwedishEJournalReport', 'SwedishXReport', 'SwedishZReport'];
